import React from 'react';
import { CookieConsentProvider } from './src/contexts/CookieConsentContext';

export const wrapRootElement = ({ element }) => (
    <CookieConsentProvider>
        {element}
    </CookieConsentProvider>
)